<template>
  <form :id="formId ? `${formId}-form` : undefined" @submit.prevent="submit">
    <PaymentFormDebug />
    <slot />
  </form>
</template>
<script setup lang="ts">
import { getCurrentInstance } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

const { submit } = usePaymentForm()
const instance = getCurrentInstance()

// In Vue 3, the component naming structure may have changed
// Attempt to extract formId, but fallback to undefined if not available
const tag = (instance?.parent?.type as any)?.name || (instance?.parent?.type as any)?.__name
const match = tag?.match?.(/vue-component-\d+-(.+)/)
const formId = match?.[1]
</script>
<style lang="scss">
@import '@/assets/scss/_reset.scss';
@import '@/assets/scss/_buttons.scss';
@import '@/assets/scss/_forms.scss';
@import '@/assets/scss/_content.scss';
</style>